<template>
    <div class="speaker">
        <h2 class="preformTitle">講演内容</h2>
        <div class="accordion" role="tablist">
            <b-card no-body class="mb-1 speakerInfoCard">
                <b-card-header header-tag="header" class="p-1 speakerInfoCard" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="dark" @click="changeIcon('kokugo')">
                        <div class="d-flex">
                            <span class="col-11">国語</span>
                            <p class="toggleIcon kokugoIcon">V</p>
                        </div>
                    </b-button>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <h3 class="alert alert-info">ご案内</h3>
                        <div class="prof">
                            <p class="text-primary linkImg" target="_blank" @click="openPDF('kokugo')">「国語科 新課程オンラインセミナーのご案内」（PDF）</p>
                            <p>※各学校様宛てにお送りしたご案内です。</p>
                        </div>
                        <h3 class="alert alert-info">講演リスト</h3>
                        <b-table class="profile" bordered head-row-variant="primary" :fields="themefield" :items="info[0].theme"></b-table>
                        <h3 class="alert alert-info">講師紹介</h3>
                        <div class="prof" v-for="(item, val) in info[0].profile" :key="val">
                            <h4>・{{item.name}}先生 （{{item.member}}）</h4>
                            <p>{{item.prof}}</p>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1 speakerInfoCard">
                <b-card-header header-tag="header" class="p-1 speakerInfoCard" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="dark" @click="changeIcon('rika')">
                        <div class="d-flex">
                            <span class="col-11">理科</span>
                            <span class="toggleIcon rikaIcon">V</span>
                        </div>
                    </b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <h3 class="alert alert-info">ご案内</h3>
                        <div class="prof">
                            <p class="text-primary linkImg" href="#" target="_blank" @click="openPDF('rika')">「理科 新課程オンラインセミナーのご案内」（PDF）</p>
                            <p>※各学校様宛てにお送りしたご案内です。</p>
                        </div>
                        <h3 class="alert alert-info">講演リスト</h3>
                        <b-table class="profile" bordered head-row-variant="primary" :fields="themefield" :items="info[1].theme"></b-table>
                        <h3 class="alert alert-info">講師紹介</h3>
                        <div class="prof" v-for="(item, val) in info[1].profile" :key="val">
                            <h4>・{{item.name}}先生 （{{item.member}}）</h4>
                            <p>{{item.prof}}</p>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-1 speakerInfoCard">
                <b-card-header header-tag="header" class="p-1 speakerInfoCard" role="tab">
                    <b-button block v-b-toggle.accordion-3 variant="dark" @click="changeIcon('syakai')">
                        <div class="d-flex">
                            <span class="col-11">地歴･公民</span>
                            <span class="toggleIcon syakaiIcon">V</span>
                        </div>
                    </b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <h3 class="alert alert-info">ご案内</h3>
                        <div class="prof">
                            <p class="text-primary linkImg" href="#" target="_blank" @click="openPDF('shakai')">「地歴･公民科 新課程オンラインセミナーのご案内」（PDF）</p>
                            <p>※各学校様宛てにお送りしたご案内です。</p>
                        </div>
                        <h3 class="alert alert-info">講演リスト</h3>
                        <b-table class="profile" bordered head-row-variant="primary" :fields="themefield" :items="info[2].theme"></b-table>
                        <h3 class="alert alert-info">講師紹介</h3>
                        <div class="prof" v-for="(item, val) in info[2].profile" :key="val">
                            <h4>・{{item.name}}先生 （{{item.member}}）</h4>
                            <p>{{item.prof}}</p>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>
</template>


<style lang="scss" scoped>
.speakerInfoCard {
  margin-bottom: 0.1rem !important;
}
.preformTitle {
  background-color: #1564AC;
  color: white;
  padding: 10px;
}

.profile{
    white-space: pre-wrap;
    word-wrap: break-word;
}
.toggleIcon {
    color: rgb(255, 255, 255);
    width: 10%;
    font-weight: 900;
    transform: scaleX(1.8);
    margin: 0;
}
.prof {
    white-space: pre-wrap;
    word-wrap: break-word;
    & > p, & > a {
        padding-left: 1em;
    }
}
.linkImg {
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
}
</style>

<script>
import jquery from 'jquery'

export default {
  name: 'SpeakerInfo',
  data() {
      return {
        subject: ['kokugo.csv','rika.csv','syakai.csv'],
        info: [],
        themefield: [
            {key: '0', label: '科目'},
            {key: '1', label: '講師'},
            {key: '2', label: '講演テーマ'}],
        lastOpen: ""
      }
  },
  mounted() {
      this.subject.forEach((el) => {
        jquery.ajax({
            async: false,
            url: process.env.VUE_APP_BASE_URL + 'api/profile/' + el,
            success: (res) => {
                let tsv = [], col = []
                let theme = [], profile = []
                tsv = res.split('@')
                col = tsv[0].split(/\n/)
                col.shift()
                col.pop()
                col.forEach((val) => {
                    let tbl = val.split(/\t/)
                    if(tbl[3]){
                        tbl[2] = tbl[2] + '\n' + tbl[3]
                        tbl.pop()
                    }
                    theme.push(tbl)
                })

                for(let i = 1; i < tsv.length - 1; i++){
                    col = tsv[i].split(/\n/)
                    col.shift()
                    col.pop()

                    let speaker = col[0].split(/\t/)
                    col.shift()
                    let profileStr = col.join('\r\n')

                    profile.push({
                        'name': speaker[1],
                        'member': speaker[0],
                        'prof': profileStr
                    })
                    console.log(profile)
                }

                this.info.push({
                    'theme': theme,
                    'profile': profile
                })
            }
        })
        console.log(this.info)
      })
  },
  methods: {
    changeIcon(sub) {
        let openIcon = 'V', closeIcon = 'Λ'
        console.log(jquery('.kokugoIcon').text())
        jquery('.kokugoIcon').text(openIcon)
        jquery('.rikaIcon').text(openIcon)
        jquery('.syakaiIcon').text(openIcon)
        if(this.lastOpen != sub) {
            jquery('.' + sub + 'Icon').text(closeIcon)
            this.lastOpen = sub
        } else {
            this.lastOpen = ''
        }
    },
    openPDF(sub) {
        window.open(process.env.VUE_APP_BASE_URL + 'pdf/' + sub + '.pdf', '_blank')
    }
  }

}
</script>
